import React from 'react'
import IndustriesHero from "./section/IndustriesHero.js"
import AllIndustriesc from "./section/AllIndustriesc.js"
const Industries = () => {
  return (
    <>
    <IndustriesHero/>
    <AllIndustriesc/>
    </>
  )
}

export default Industries